/**
 * Incasso Kanban Configuration
 *
 * Configuration for the Incasso kanban board using the global Kanban component.
 * Follows the exact same pattern as helpdeskKanbanConfig.tsx.
 */

import { KanbanConfig } from '../types';
import { IncassoTicket, IncassoPhase } from 'screens/rental/pages/incasso/shared/incassoTypes';
import { incassoPhaseColumns } from 'screens/rental/pages/incasso/configs/incassoPhaseConfig';

/**
 * Incasso Kanban Configuration
 *
 * This config defines how the Incasso kanban should look and behave:
 * - Uses phase columns from incassoPhaseConfig (single source of truth)
 * - Shows count per column
 * - No add button (tickets are created via sync or manually from a different flow)
 * - Page scroll (not per-column scrollbars)
 */
export const incassoKanbanConfig: KanbanConfig<IncassoTicket, IncassoPhase> = {
  // Column definitions from incassoPhaseConfig
  columns: incassoPhaseColumns,

  // Get the phase/status for a ticket
  getItemStatus: (ticket: IncassoTicket) => ticket.phase,

  // Show count badge per column
  showCount: true,

  // No add button — tickets are created via sync or dedicated flow
  showAddButton: false,

  // Empty state configuration
  emptyState: {
    message: 'Geen dossiers',
  },

  // Use page scroll instead of per-column scrollbars
  scrollableColumns: false,
};
